import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'
import { TipoMuroEnum } from './Enum/TipoMuroEnum'
import { TipoProjetoEnum } from './Enum/TipoProjetoEnum'

export type DadosMuros = {
  tipoMuroExterno: string
  perimetroExterno: string
  tipoMuroInterno: string | number
  valido: boolean
}

export const dadosMurosValorDefault = {
  tipoMuroExterno: '',
  perimetroExterno: '',
  tipoMuroInterno: ''
} as DadosMuros

export class ValidacaoDadosMuros {
  tipoMuroExterno: string
  perimetroExterno: string
  tipoMuroInterno: string

  constructor(tipoMuroExterno = '', perimetroExterno = '', tipoMuroInterno = '') {
    this.tipoMuroExterno = tipoMuroExterno
    this.perimetroExterno = perimetroExterno
    this.tipoMuroInterno = tipoMuroInterno
  }

  validarTipoMuroPreenchido(tipoMuro: string) {
    if (tipoMuro === '') {
      return campoObrigatorio
    }

    return ''
  }

  validarPerimetroPreenchidoValorDiferenteZero(valor: string, tipoMuro: string) {
    if (tipoMuro !== TipoMuroEnum.SemMuro && (!valor || valor === '')) {
      return campoObrigatorio
    }

    if (parseFloat(valor) === 0) {
      return campoDeveSerMaiorQueZero
    }

    return ''
  }

  validarTodosCampos(state: DadosMuros, tipoProjeto: string): boolean {
    if (tipoProjeto === TipoProjetoEnum.LoteamentoAberto && this.validarMurosInternos(state)) {
      return true
    }

    if (tipoProjeto === TipoProjetoEnum.CondominioIncorporacao && this.validarMurosInternos(state) && this.validarMurosExternos(state)) {
      return true
    }

    return false
  }

  validarMurosInternos(state: DadosMuros): boolean {
    if (state.tipoMuroInterno == TipoMuroEnum.Rebocado || state.tipoMuroInterno == TipoMuroEnum.Frisado || state.tipoMuroInterno == TipoMuroEnum.SemMuro) {
      return true
    }

    return false
  }

  validarMurosExternos(state: DadosMuros): boolean {
    if (state.tipoMuroExterno == TipoMuroEnum.Rebocado && state.perimetroExterno != '' && this.perimetroExterno === '') {
      return true
    }

    if (state.tipoMuroExterno == TipoMuroEnum.Frisado && state.perimetroExterno != '' && this.perimetroExterno === '') {
      return true
    }

    if (state.tipoMuroExterno == TipoMuroEnum.SemMuro) {
      return true
    }

    return false
  }
}
